var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBinDeleteWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "17px",
    viewBox: "0 0 13 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBinDelete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.508,14.4731167 L1.508,3.19761905 L11.4226667,3.19761905 L11.4226667,14.4731167 C11.4226667,15.5114314 10.6832107,16.352381 9.77024804,16.352381 L3.16045735,16.352381 C2.24745598,16.352381 1.508,15.5114314 1.508,14.4731167 Z M9.05668553,0.917446615 L12.324,0.917446615 L12.324,2.67142857 L0.606666667,2.67142857 L0.606666667,0.917446615 L3.87398114,0.917446615 L4.67876999,0.0404761905 L8.25189668,0.0404761905 L9.05668553,0.917446615 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup---quick-msg---select-template",
    transform: "translate(-872.000000, -350.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QUICK-MESSAGE",
    transform: "translate(317.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icBinDelete",
    transform: "translate(555.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/primary-green",
    mask: "url(#mask-2)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.900000, -3.642857)",
    id: "colour/mid-grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 20.28 0 20.28 23.6785714 0 23.6785714"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBinDeleteWhite);
export default __webpack_public_path__ + "static/media/icBinDeleteWhite.8ece20089ec6c752794b0972651c19af.svg";
export { ForwardRef as ReactComponent };